import { useState } from 'react';

export const PAGE_SIZE_OPTIONS = [15, 50, 150, 200, 300, 500];

// A paginated list's rows-per-page choice, remembered per list and per user in
// this browser. `listKey` names the list (e.g. 'invoices'); the first option is
// the default.
export default function usePageSize(listKey, options = PAGE_SIZE_OPTIONS) {
  const storageKey = `${listKey}RowsPerPage_${localStorage.getItem('userId') || 'anon'}`;

  const [pageSize, setPageSize] = useState(() => {
    try {
      const saved = Number(localStorage.getItem(storageKey));
      return options.includes(saved) ? saved : options[0];
    } catch {
      return options[0];
    }
  });

  function changePageSize(size) {
    setPageSize(size);
    try {
      localStorage.setItem(storageKey, String(size));
    } catch {
      // non-fatal — the choice just won't persist
    }
  }

  return [pageSize, changePageSize];
}
